import { Button } from "@/components/Atoms";
import Typography from "@/foundation/Typography/V2";

import { classNameGenerator } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./BookYogaNutritionTrialRibbon.module.scss";

interface BookYogaNutritionTrialRibbonProps {
  onCTAClick: (data: any) => void;
}

const BookYogaNutritionTrialRibbon: React.FC<
  BookYogaNutritionTrialRibbonProps
> = ({ onCTAClick }) => {
  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  if(!data?.trialRibbon)
    return <></>
  
  const { title, description, ctaText } = data?.trialRibbon || {};
  const { currencySymbol, price } = data?.trialData || {};

  return (
    <section className={cls("bookYogaNutritionTrialRibbon")}>
      <div className={cls("container")}>
        <div className={cls("topSection")}>
          {currencySymbol && price!==null && <Typography
            variant="heading3"
            className={cls("title")}
            dangerouslySetInnerHTML={{
              __html: `${title} ${currencySymbol}&nbsp;${price}`,
            }}
          />}
          <Typography variant="paragraph1" className={cls("description")}>
            {description}
          </Typography>
        </div>
        <div className={cls("bottomSection")}>
          <Button
            variant="outline"
            className={cls("actionButton")}
            onClick={onCTAClick}
          >
            {ctaText}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default BookYogaNutritionTrialRibbon;
